// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__9LX7E","container":"NotFound_container__wXpoO","title":"NotFound_title__TyHgN","video_item":"NotFound_video_item__2abMM"};